import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';

const ClientBudgetStatusesState = (state: RootState) => state.supportAtHome.clientBudgetStatuses;

export const selectClientBudgetStatuses = (state: RootState) => ClientBudgetStatusesState(state).rows;
export const selectClientBudgetStatusesLoading = (state: RootState) => ClientBudgetStatusesState(state).loading;
export const selectClientBudgetStatusesError = (state: RootState) => ClientBudgetStatusesState(state).error;

export const lookupClientBudgetStatuses = createSelector([selectClientBudgetStatuses], (rows) =>
  rows.map(({ id, name }) => ({ value: id, label: name })),
);
